import { render, staticRenderFns } from "./AddStartup.vue?vue&type=template&id=0ea9eddc&scoped=true"
import script from "./AddStartup.vue?vue&type=script&lang=js"
export * from "./AddStartup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9eddc",
  null
  
)

export default component.exports